module.exports = __webpack_public_path__ + "img/baggerarbeiten.04d07f06.svg";